export default __webpack_public_path__ + "static/media/others1.75006f71.jpg";